export function is404DecorationOn() {
  return process.env.REACT_APP_FEATURE_FLAG_404_DECORATION === '1';
}

export function isPublisherMerchantGalleryOn() {
  return process.env.REACT_APP_FEATURE_FLAG_PUBLISHER_MERCHANT_GALLERY === '1';
}
